import { useEffect, useState } from 'react';

import { ArtifactUnpacked } from '@/services/types/artifact-types';

interface UseArtifactNavigationProps {
  artifacts: ArtifactUnpacked[];
  onSelect?: (artifact: ArtifactUnpacked) => void;
}

export const useArtifactNavigation = ({
  artifacts,
  onSelect,
}: UseArtifactNavigationProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);

  // Reset selection when artifacts change
  useEffect(() => {
    setSelectedIndex(-1);
  }, [artifacts]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (artifacts.length === 0) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setSelectedIndex((prev) =>
          prev < artifacts.length - 1 ? prev + 1 : prev,
        );
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
      } else if (e.key === 'Enter' && selectedIndex >= 0) {
        e.preventDefault();
        const artifact = artifacts[selectedIndex];
        if (artifact && onSelect) {
          onSelect(artifact);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [artifacts, selectedIndex, onSelect]);

  return {
    selectedIndex,
    setSelectedIndex,
  };
};
